import React, { useEffect, useRef, useState } from "react";
import PaginationNew from "../common/Pagination";
import { useDispatch } from "react-redux";
import { formatedDate } from "../../utilities/ConvertDateFormat";
import { useAlert } from "react-alert";
import { GenUtilities } from "../../utilities/GenUtilities";
import api from "../../seller-apis/api";
var filterData = {
  "offset":1,
  "size":10
};

function DailyReport(props) {
  const dispatch = useDispatch();
  const [transaction, setTransaction] = useState([]);
  const [totalrecords, setTotalRecords] = useState();
  const [selectedPage, setSelectedPage] = useState(1);
  const [selectedData, setSelectedData] = useState(null);
  const [showUnlock, setShowUnlock] = useState(false);
  const [selectedLeadId, setSelectedLeadId] = useState(false);
  const [selectedPrice, setSelectedPrice] = useState(0);
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const dateRange = GenUtilities.getDateRange(30);
  const [sortdatefrom, setsortdatefrom] = useState(dateRange[0]);
  const [sortdateto, setsortdateto] = useState(dateRange[1]);
  const [filterButtonDisabled, setFilterButtonDisabled] = useState(false);
  const [leadIndex, setLeadIndex] = useState(0);
  const alert = useAlert();
  const statusArray = ["NOT_INTERESTED", "CONVERTED", "FORWARDED"];
  const toggleDropdown = (index) => {
    setLeadIndex(index);
    setDropdownOpen(!isDropdownOpen);
  };
  var dateFromWeb;
  var dateToWeb;
  const handleUnlockClose = () => {
    setShowUnlock(false);
  };
  function setdateweb(e, type) {
    setFilterButtonDisabled(false);
    dateFromWeb = sortdatefrom;
    dateToWeb = sortdateto;
    if (type === "from") {
      dateFromWeb = e.target.value;
    } else {
      dateToWeb = e.target.value;
      // setHistsortdateto(e.target.value)
    }

    if (dateFromWeb != undefined && dateToWeb != undefined) {
      setsortdatefrom(dateFromWeb);
      setsortdateto(dateToWeb);
      let fromDate = new Date(dateFromWeb);
      let toDate = new Date(dateToWeb);
      let diffDate = toDate.getTime() - fromDate.getTime();
      let daydiffer = diffDate / (1000 * 60 * 60 * 24);
      daydiffer = Math.floor(daydiffer);
      console.log(daydiffer);
      if (daydiffer > 30) {
        setFilterButtonDisabled(true);
        alert.info("Date range cannot be more than 30 days.", {
          position: "top center",
        });
      } else if (daydiffer < 0) {
        setFilterButtonDisabled(true);
        alert.info("Please select a valid date range.");
      }
    }
  }
  useEffect(() => {
    filterData["filter"] = {
      "from-createdAt": sortdatefrom + "T00:00:00",
      "to-createdAt": sortdateto + "T23:59:59",
    };
    getTransaction(filterData);
  }, []);

  const applyFilter = () => {
    filterData["filter"] = {
      "from-createdAt": sortdatefrom + "T00:00:00",
      "to-createdAt": sortdateto + "T23:59:59",
    };
    getTransaction(filterData);
  };

  function getTransaction(data = filterData) {
    // api.QandA.fetchQA(fetchunansQA(data)).then((res) => {
    api.customerLeads.getDailyTransactionReport(data).then((res) => {
      console.log("Leads", res);
      // setTransaction(res.data.records);
      // setTotalRecords(res.data.totalRecords);
    });
  }
  function paginate(data) {
    filterData = {
      pageNo: data.number,
      size: 12,
    };
    getTransaction(filterData);
    setSelectedPage(data.number);
  }
  // const refreshData = () => {
  //   getQA(filterData, "action");
  // };
  return (
    <>
      <div className="d-flex mb-3 justify-content-start">
        {/* ******** */}
        <div className="theme-shed1 p-2">
          <div className="m-auto mt-1">
            <span className="payment_dates">
              From: -{" "}
              <input
                type="date"
                value={sortdatefrom}
                onChange={(e) => setdateweb(e, "from")}
              ></input>
            </span>
            <span className="mx-2 payment_dates">
              To: -{" "}
              <input
                type="date"
                value={sortdateto}
                onChange={(e) => setdateweb(e, "to")}
              ></input>
            </span>
            <span>
              <button
                disabled={filterButtonDisabled}
                className="apply-btn px-3 py-1 ff_Pop fs-14"
                onClick={() => applyFilter()}
              >
                Apply
              </button>
            </span>
            {/* <span><button className={`payment_btn_export px-3 py-1 ff_Pop fs-14 ms-1 ${removeFilterClass}`} onClick={() => clearFilters()}>Clear</button></span> */}
          </div>
        </div>
        {/* ****** */}
      </div>
      <div className="question-container">
        <table className="w-100 new-table-design pt-2">
          <tr>
            <th>Date</th>
            <th>Leads Unlocked</th>
            <th>Amount Deducted</th>
            
          </tr>
          {transaction.length > 0 &&
            transaction.map((item, index) => {
              // let baseImg = "";
              // item.productId.images.map((item) => {
              //   if (item.baseImage === true) {
              //     if (item.image.startsWith("products")) {
              //       baseImg = item.image;
              //     } else {
              //       let img = item.image.substr("41");
              //       baseImg = img;
              //     }
              //   } 
              // });
              return (
                <tr>
                  <td>
                    <div className="border-x">
                      {formatedDate(item.createdAt)}
                    </div>
                  </td>
                  <td>
                    <div className=" text-left border-x px-2">
                      5
                    </div>
                  </td>
                  <td>
                    <div className=" text-left border-x px-2">
                      &#8377; {item.amount}
                    </div>
                  </td>
                </tr>
              );
            })}
          {transaction.length == 0 ? (
            <tr>
              <td className="py-2" colspan="99">
                No data found
              </td>
            </tr>
          ) : (
            <></>
          )}
        </table>
        <PaginationNew
          number={totalrecords}
          paginate={paginate}
          activ={selectedPage}
          comp={"details"}
        />
      </div>
    </>
  );
}

export default DailyReport;
